module.exports = __webpack_public_path__ + "static/media/user_hover.c800823c.svg";